var waitFor = require("../utils/waitFor");
var posiSession = require("../utils/posi-session");

function isRohs(partNumber) {
  return (
    partNumber.indexOf("/AA") > -1 ||
    partNumber.indexOf("-AA") > -1 ||
    partNumber.indexOf("EC") === 0 ||
    partNumber.indexOf("PA") === 0
  );
}

waitFor("body.part-search-results", function () {
  var dt = require("datatables.net")(window, jQuery),
    dt_fixedheader = require("datatables.net-fixedheader")(window, jQuery),
    dtUtils = require("../utils/dtUtils"),
    posiLogger = require("../utils/event-logger.js")(),
    $searchResultsTable = $("#part-search-results-table");

  // Results table
  var colData = [
    {
      title: "Part number",
      func: function (data) {
        return '<span class="part-number">' + data.partNumber + "</span>";
      },
      className: "col-emphasize",
      width: "250px",
    },
    {
      title: "RoHS",
      func: function (data) {
        if (isRohs(data.partNumber) || data.rohs)
          return '<span class="rohs"></span><span class="card-only"> RoHS Compliant</span>';

        return '<span class="non-rohs"></span><span class="card-only"> Non-RoHS Compliant</span>';
      },
    },
    {
      title: "2D Drawing",
      func: function (data) {
        if (data.hasPDF) {
          var pdfLink = data.pdfURL ? data.pdfURL : "#";

          return (
            '<a href="' +
            pdfLink +
            '" data-part="' +
            data.partNumber +
            '" class="pdf download-2d ' +
            (data.pdfURL ? "no-trailing-slash" : "") +
            '">Download</a>' +
            (data.pdfRevision
              ? '<span class="pdf-revision">Rev ' + data.pdfRevision + "</span>"
              : "")
          );
        }

        return (
          '<a class="request-drawing request-2d" data-part="' +
          data.partNumber +
          '" href="#">Request<span class="card-only">&nbsp;2D Drawing</span></a>'
        );
      },
      noSort: true,
    },
    {
      title: "3D Drawing",
      func: function (data) {
        var stepPartNumber = false;

        if (data.hasStep || data.onTP) {
          stepPartNumber = data.partNumber;
        } else if (data.matchHasStep || data.matchHasTP) {
          if (isRohs(data.partNumber))
            stepPartNumber = data.partNumber.substring(
              0,
              data.partNumber.length - 3
            );
          else stepPartNumber = data.partNumber + "/AA"; // TODO: accommodate "-AA" too
        }

        if (data.onTP || data.matchHasTP)
          return (
            '<a href="#" data-part="' +
            stepPartNumber +
            '" class="traceparts-preview button button--blue-light button--small">View/Download<span class="card-only">&nbsp;3D</span></a>'
          );

        if (stepPartNumber) {
          var stepLink = data.stepURL ? data.stepURL : "#";
          return (
            '<a href="' +
            stepLink +
            '" data-part="' +
            stepPartNumber +
            '" class="download-3d stp">Download</a>'
          );
        }

        return (
          '<a class="request-drawing request-3d" data-part="' +
          data.partNumber +
          '" href="#">Request<span class="card-only">&nbsp;3D Drawing</span></a>'
        );
      },
      noSort: true,
    },
  ];

  // process results for columns
  $searchResultsTable.DataTable({
    data: dtUtils.formatResultsData(window.partSearchResults, colData),
    columns: dtUtils.buildDataTablesColumns(colData),
    fixedHeader: false,
    searching: false,
    lengthChange: false,
    // autoWidth: false,
    info: false,
    dom: '<"dataTables-top-pagination"p>t<"dataTables-bottom-pagination"p>',
  });

  // log search and result count
  var results2d = 0,
    results3d = 0,
    isValidated = false,
    searchedNumber = $('input[name="part-search"]').val();

  // count results, check if validated
  $.each(window.partSearchResults, function (i, result) {
    if (result.hasStep) results3d++;

    if (result.hasPDF) results2d++;

    if (result.partNumber == searchedNumber) isValidated = true;
  });

  posiLogger.log({
    event_type: "part-results",
    part_number: searchedNumber,
    results_2d: results2d,
    results_3d: results3d,
    validated: isValidated,
  });

  // scroll to top on page change
  $searchResultsTable.on("page.dt", function () {
    $("html, body").animate(
      {
        scrollTop: $(".search-results__meta").offset().top - 40,
      },
      300
    );
  });
});
